import React, { useState } from 'react';
import './contact.css';
// Importer FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faEnvelope, 
  faPhone, 
  faComments,
  faRocket,
  faMap,
  faCheckCircle,
  faTimesCircle,
  
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faLinkedinIn, faTiktok } from '@fortawesome/free-brands-svg-icons';

const CONTACT = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const services = [
    { value: '', label: 'Sélectionnez un service' },
    { value: 'web', label: 'Création Web & Solutions Digitales' },
    { value: 'marketing', label: 'Marketing Digital & Réseaux Sociaux' },
    { value: 'graphisme', label: 'Identité Visuelle & Création Graphique' },
    { value: 'video', label: 'Contenu Vidéo & Animations Logo' },
    { value: 'communication', label: 'Automatisation & Communication Pro' },
    { value: 'accompagnement', label: 'Accompagnement & Formations Stratégiques' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    if (!formData.name || !formData.email || !formData.message) {
      setSubmitStatus({ type: 'error', message: 'Veuillez remplir les champs obligatoires.' });
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch('https://moseraigc.com/api/send_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus({ type: 'success', message: result.message });
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus({ type: 'error', message: result.message });
      }

    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Erreur serveur. Veuillez réessayer.' });
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        {/* En-tête avec titre et description */}
        <div className="contact-header">
          <div className="section-badge">
            <span className="badge-text">PRENDRE CONTACT</span>
          </div>
          <h2 className="section-title">
            <span className="title-line">Développons votre</span>
            <span className="title-line highlight">projet ensemble</span>
          </h2>

        </div>

        <div className="contact-grid">
          {/* Colonne gauche : Informations de contact */}
          <div className="contact-info-column">
            <div className="contact-info-card">
              <h3 className="info-title">Nos coordonnées</h3>
              
              <div className="contact-info-list">
                <div className="info-item">
                  <div className="info-icon">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </div>
                  <div className="info-content">
                    <h4>Adresse</h4>
                    <p>Carrefour Djenontin<br />Abomey-Calavi, Benin</p>
                    <a 
                      href="https://maps.google.com/?q=123+Avenue+de+l'Innovation+Paris" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="map-link"
                    >
                      Voir sur la carte →
                    </a>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="info-content">
                    <h4>Email</h4>
                    <div className="email-list">
                      <a href="mailto:contact@moseraigc.com">contact@moseraigc.com</a>
                      <a href="mailto:supportclient@moseraigc.com">supportclient@moseraigc.com</a>
                    </div>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className="info-content">
                    <h4>Téléphone</h4>
                    <p className="phone-number">+229 01 62 60 49 43 / +229 01 54 86 34 86</p>
                    <p className="opening-hours">
                      <strong>Horaires :</strong> Lun - Ven • 8h - 18h
                    </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FontAwesomeIcon icon={faComments} />
                  </div>
                  <div className="info-content">
                    <h4>Réseaux sociaux</h4>
                    <div className="social-contact">
                      <a href="https://www.linkedin.com/company/mose-rai-gc/" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faLinkedinIn} /> LinkedIn
                      </a>
                      <span className="separator">•</span>
                      <a href="https://www.facebook.com/moseraiglobalcorp/" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faFacebook} /> Facebook
                      </a>
                      <span className="separator">•</span>
                      <a href="https://www.tiktok.com/@moseraiglobalcorp" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faTiktok} /> TikTok
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              
            </div>

            
            <div className="contact-image">
              <img src="/images/21.jpg" alt="" className="contact-visual"/>
            </div>
          </div>

          {/* Colonne droite : Formulaire */}
          <div className="contact-form-column">
            <div className="form-card">
              <div className="form-header">
                <h3 className="form-title">Parlez-nous de votre projet</h3>
                <p className="form-subtitle">
                  Remplissez ce formulaire et notre équipe vous recontactera 
                  sous 24h pour une consultation gratuite.
                </p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">
                      Nom complet *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Jean Dupont"
                      required
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Email professionnel *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="jean.dupont@entreprise.com"
                      required
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="company" className="form-label">
                      Entreprise
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Nom de votre entreprise"
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">
                      Téléphone
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+XXX XX XX XX XX"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service" className="form-label">
                    Service concerné
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="form-select"
                  >
                    {services.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">
                    Décrivez votre projet *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Décrivez votre projet, vos objectifs, votre budget et vos délais..."
                    rows="6"
                    required
                    className="form-textarea"
                  />
                  <div className="textarea-counter">
                    {formData.message.length}/1000 caractères
                  </div>
                </div>

                <div className="form-actions">
                  <div className="form-consent">
                    <input
                      type="checkbox"
                      id="consent"
                      name="consent"
                      required
                      className="consent-checkbox"
                    />
                    <label htmlFor="consent" className="consent-label">
                      J'accepte que mes données soient utilisées pour me recontacter.
                      <a href="/politique-confidentialite" className="privacy-link">
                        Politique de confidentialité
                      </a>
                    </label>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner"></span>
                        Envoi en cours...
                      </>
                    ) : (
                      <>
                        <span className="btn-icon">
                          <FontAwesomeIcon icon={faRocket} />
                        </span>
                        Envoyer ma demande
                        <span className="btn-arrow">→</span>
                      </>
                    )}
                  </button>

                    {/* Messages de statut */}
                {submitStatus && (
                  <div className={`form-status ${submitStatus.type}`}>
                    <span className="status-icon">
                      {submitStatus.type === 'success' ? (
                        <FontAwesomeIcon icon={faCheckCircle} />
                      ) : (
                        <FontAwesomeIcon icon={faTimesCircle} />
                      )}
                    </span>
                    <span className="status-message">{submitStatus.message}</span>
                  </div>
                )}

                </div>

                <div className="form-footer">
                  <p className="form-note">
                    * Champs obligatoires. Nous vous répondrons sous 24h ouvrées.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Carte Google Maps intégrée */}
        <div className="contact-map">
          <div className="map-container">
            {/* À DÉCOMMENTER pour intégrer Google Maps */}
            
            <iframe
                title="Localisation MOSE RAI GC"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d247.78773320762102!2d2.3416379627962196!3d6.444897301690058!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sfr!2sbj!4v1765551004515!5m2!1sfr!2sbj"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            
            <div className="map-placeholder">
              <div className="placeholder-content">
                <span className="map-icon">
                  <FontAwesomeIcon icon={faMap} />
                </span>
                <h4>Localisation MOSE RAI GC</h4>
                <p>123 Avenue de l'Innovation, 75000 Paris</p>
                <a 
                  href="https://maps.google.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-outline"
                >
                  Ouvrir dans Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CONTACT;